export enum PromoType {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
}